export const namespaced = true

export const state = {
  company: 'ТендерПро',
  app: 'Ассистент',
  description: 'Ваши закупки от заявки до исполнения договора с аналитикой',
  resources: [{
    title: 'ЭТП ТендерПро',
    url: 'http://www.tender.pro'
  }, {
    title: 'Договор',
    url: 'https://doc.tender.pro'
  }, {
    title: 'Услуги',
    url: 'http://company.help.tender.pro/services.html'
  }, {
    title: 'О компании',
    url: 'http://company.help.tender.pro'
  }]
}

export const getters = {
  company (state) {
    return state.company
  },
  app (state) {
    return state.app
  },
  description (state) {
    return state.description
  },
  address (state) {
    return state.address
  },
  resources (state) {
    return state.resources
  }
}
